import './PillSelector.css';

interface PillSelectorOption {
  label: string;
  value: string;
}

interface PillSelectorProps {
  label: string;
  options: PillSelectorOption[];
  value: string | null;
  onSelect: (value: string) => void;
  error?: string;
}

export const PillSelector = ({ label, options, value, onSelect, error }: PillSelectorProps) => {
  return (
    <div className="pill-selector">
      <span className="pill-selector__label" id="pill-selector-group-0">{label}</span>
      <div className="pill-selector__options" role="group" aria-labelledby="pill-selector-group-0">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`pill-selector__pill ${value === option.value ? 'pill-selector__pill--selected' : ''}`}
            onClick={() => onSelect(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      {error && <span className="pill-selector__error">{error}</span>}
    </div>
  );
};
